import {useNavigate} from "react-router-dom";
import {ButtonEdit, ButtonDetail, ButtonDelete} from "../../component/common/Button"
import {getRegTypeBadge, getTextWorkCity, getTextWorkTime, getTextVisaStat, getValidObjBadge} from "../../component/common/BaseUtil"

export function PersonCardMypage(props) {
    return (
        <div class="card" key={props.index} style={{ marginTop: '15px', marginBottom: '15px' }}>
            <div class="card-body">
            <h4 class="card-title" style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold' }}>{props.object.objTitle}</h4>
                <h6 class="text-muted card-subtitle mb-2" style={{ fontFamily: 'Nanum Gothic' }}>근무도시: {getTextWorkCity(props.cityList, props.object.workCity)} / 근무형태: {getTextWorkTime(props.object.workTime)}</h6>
                <h6 class="text-muted card-subtitle mb-2" style={{ fontFamily: 'Nanum Gothic' }}>비자상태: {getTextVisaStat(props.object.visaStat)}</h6>
                <p class="card-text">{props.object.pvIntro == null ? "" : props.object.pvIntro.replace( /(<([^>]+)>)/ig, '')}</p>
                <p class="card-text">{getRegTypeBadge(props.object.regType)}</p>
                <p class="card-text">{getValidObjBadge(props.object.validObj)}</p>
                <ButtonDetail id={props.object.id} url={"/person?id="} returnTo={props.returnTo}/>
                <ButtonEdit id={props.object.id} url={"/person_modi_mypage?id="}/>
                <ButtonDelete id={props.object.id} objectTitle={props.object.objTitle} url={"/delete/person"}/>
            </div>
        </div> 
    );
}